var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-view',[_c('associate-section',{attrs:{"heading":_vm.$t('associateHeading'),"people":_vm.associateTeam}}),_vm._v(" "),_c('cooperation-section',{attrs:{"heading":_vm.$t('cooperationHeading'),"people":_vm.cooperationTeam}}),_vm._v(" "),_c('photo-section',{attrs:{"photo":_vm.teamPhoto}}),_vm._v(" "),_c('worked-section',{attrs:{"heading":_vm.$t('workedHeading'),"people":_vm.workedTeam}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3ec198","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Team/TeamContainer.vue
// module id = null
// module chunks = 